module.exports = __webpack_public_path__ + "img/taib5.f666849e.png";